module.exports = __webpack_public_path__ + "static/media/half_circle_o.401bf6e5.svg";